import { render, staticRenderFns } from "./AlgoliaRefresh.vue?vue&type=template&id=4e69cc57"
import script from "./AlgoliaRefresh.vue?vue&type=script&lang=js"
export * from "./AlgoliaRefresh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports